// extracted by mini-css-extract-plugin
module.exports = {"root":"index_root_3MqUm","icon":"index_icon_3cb9U","link-default":"index_link-default_1fYKw","link-danger":"index_link-danger_3AKUW"};